/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RetrieveSupplierConditionsRestResponse } from '../../models/retrieve-supplier-conditions-rest-response';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface FindAllSupplierConditions$Params {}

export function findAllSupplierConditions(
  http: HttpClient,
  rootUrl: string,
  params?: FindAllSupplierConditions$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<RetrieveSupplierConditionsRestResponse>>> {
  const rb = new RequestBuilder(rootUrl, findAllSupplierConditions.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RetrieveSupplierConditionsRestResponse>>;
    }),
  );
}

findAllSupplierConditions.PATH = '/supplier-condition';
